// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"563":"ebeb96f3","4535":"5d7be27e","4576":"ebeb96f3","7563":"bbf9771f","8407":"05ee84a1"}[chunkId] + ".chunk.css";
};